import './app.css';
import '@babel/polyfill';

import './video/bg.webm';
import './video/bg.mp4';

import WebFont from 'webfontloader';
import lazySizes from 'lazysizes';
import {analyticsEvent, attrEvents} from './js/analytics';
import SmoothScroll from 'smooth-scroll';
import gumshoe from 'gumshoejs';
import * as basicScroll from 'basicscroll';

/* is production */
const isProd = process.env.NODE_ENV === 'production';

/* service worker */
if ('serviceWorker' in navigator && isProd) {
    window.addEventListener('load', () => {
        navigator.serviceWorker.register('./sw.js');
    });
}

/* fonts */
WebFont.load({
    custom: {
        families: ['Vesterbro:i4'],
        urls: ['./css/fonts.css']
    },
    google: {
        families: ['Montserrat:400,500,600:cyrillic']
    }
    /*
    typekit: {
        id: 'xxxxxx'
    }*/
});

/* analytics (EXAMPLE: analyticsEvent('Button', 'click', 'Play');) */
analyticsEvent();
attrEvents();

/* lazy loading (https://github.com/aFarkas/lazysizes) */
lazySizes.init();

/* share buttons with lazyloading */
const shareButtonsContainer = document.querySelector('.share');
if (shareButtonsContainer !== null) {
    shareButtonsContainer.addEventListener('lazyloaded', () => {
        import(/* webpackPrefetch: true */ './js/share').then(func => {
            func.default();
        });
    });
}

/* webp pictures */
const webpElements = [...document.querySelectorAll('[data-webp][data-webp-fallback]')];
if (webpElements.length > 0) {
    import(/* webpackPrefetch: true */ './js/webp').then(func => {
        func.default(webpElements);
    });
}

/* parallax scroll */
const positions = {
    start: {
        metal: ['top-bottom', 'top-bottom', 'top-bottom'],
        traditions: ['top-bottom', 'top-bottom', 'top-bottom', 'top-bottom'],
        technology: ['top-bottom', 'top-bottom', 'top-bottom', 'top-bottom'],
        forthefuture: ['top-bottom', 'top-bottom', 'top-bottom']
    },
    end: {
        metal: ['bottom-middle', 'bottom-middle', 'middle-middle'],
        traditions: ['bottom-middle', 'bottom-middle', 'bottom-middle', 'bottom-middle'],
        technology: ['bottom-middle', 'bottom-middle', 'bottom-middle', 'bottom-middle'],
        forthefuture: ['bottom-middle', 'bottom-middle', 'bottom-middle']
    },
    from: {
        metal: ['-210px', '-120px', '-175px'],
        traditions: ['-40px', '-135px', '-115px', '-175px'],
        technology: ['-165px', '-100px', '-100px', '-120px'],
        forthefuture: ['-200px', '-140px', '-200px']
    },
    to: {
        metal: ['-50px', '50px', '-55px'],
        traditions: ['-140px', '-200px', '-55px', '-35px'],
        technology: ['-25px', '50px', '40px', '20px'],
        forthefuture: ['-50px', '40px', '135px']
    }
};

const scrollPicsOnPage = pageClass => {
    [...document.querySelectorAll(`#${pageClass} .section__pic`)].forEach(pic => {
        const section = pic.dataset.section;
        const index = pic.dataset.index;

        const instance = basicScroll.create({
            elem: pic,
            from: positions.start[section][index],
            to: positions.end[section][index],
            direct: true,
            props: {
                '--translate-y': {
                    from: positions.from[section][index],
                    to: positions.to[section][index],
                    timing: 'sineIn'
                }
            }
        });

        instance.start();
    });
};

scrollPicsOnPage('metal');

/* scroll */
new SmoothScroll('a[href*="#"]');

/* side nav */
gumshoe.init({
    offset: 100
});

/* nav dialog */
{
    const navDialog = document.querySelector('.navdialog');

    /* close nav dialog by button */
    document.querySelector('.control--nav').addEventListener('click', () => {
        if (navDialog.hasAttribute('data-open')) {
            navDialog.removeAttribute('data-open');
        } else {
            navDialog.setAttribute('data-open', 'true');
        }
    });

    /* close nav dialog by bg */
    navDialog.addEventListener('click', e => {
        if (e.target === navDialog) {
            navDialog.removeAttribute('data-open');
        }
    });

    /* close nav dialog by link */
    [...navDialog.querySelectorAll('a[href*="#"]')].forEach(link => {
        link.addEventListener('click', () => {
            navDialog.removeAttribute('data-open');
        });
    });
}

/* section nav */
{
    [...document.querySelectorAll('a[href*="#"]')].forEach(link => {
        const linkHref = link.getAttribute('href').substring(1);
        const linkSection = document.getElementById(linkHref);

        if (linkSection.hasAttribute('data-hidden')) {
            link.addEventListener('click', () => {
                linkSection.removeAttribute('data-hidden');
                gumshoe.init();
                scrollPicsOnPage(linkHref);

                const showPrevSection = section => {
                    if (section.previousSibling !== null && section.previousSibling.hasAttribute('data-hidden')) {
                        section.previousSibling.removeAttribute('data-hidden');
                        gumshoe.init();
                        scrollPicsOnPage(section.previousSibling.getAttribute('id'));
                        showPrevSection(section.previousSibling);
                    }
                };
                showPrevSection(linkSection);
            });
        }
    });
}
